import moment from 'moment';

export function formatDate(date) {
    return moment(date).format('YYYY-MM-DD');
}

export function formatTime(time) {
    return moment(time, "HH:mm").format('HH:mm:ss');
}
